export enum UserType {
  Person = 1,
  Bussiness = 2,
}
